import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Dialog } from '@app/components';

import {
  MarkasCompletedContainer,
  ChecklistButtonContainer,
  CancelButton,
  CompleteSavingIndicator,
  MarkValue,
  CompletedFooter,
} from '@app/modules/transaction-details/transactions-details-components';
import { ActivityLogInfo } from '@app/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { primaryColor } from '@app/styles';
import { useMarkasCompleted } from '@app/graphql';
type Props = {
  onModalClose?: any;
  userFirebaseId: string;
  getStatus: (e: string) => void;
  getActivityLogData: (e: ActivityLogInfo[]) => void;
  transactionCode: string;
};
let activityLog: ActivityLogInfo[] = [];

export default function AdditionalQuestionsModal(props: Props) {
  const {
    onModalClose,
    userFirebaseId,
    getStatus,
    getActivityLogData,
    transactionCode,
  } = props;
  const [submitMarkasCompleted] = useMarkasCompleted();
  const { transactionId }: any = useParams();
  const [saving, updatesaving] = React.useState<boolean>(false);
  const getActivityLog = () => {
    activityLog.push({
      transactionId: transactionId,
      firebaseId: userFirebaseId,
      item: transactionCode,
      description: 'has been marked as Complete by ',
    });
    return activityLog;
  };

  const submitChecklistData = () => {
    updatesaving(true);
    const Variables = {
      transactionId: transactionId,
      completed: userFirebaseId,
      activityLog: getActivityLog(),
    };
    submitMarkasCompleted({ variables: Variables }).then((res: any) => {
      if (res.data.markasCompelted.success) {
        const {
          markasCompelted: { transaction },
        } = res.data;
        const { status = '', activityLog = [] } = transaction;
        getStatus(status);
        getActivityLogData(activityLog);
        updatesaving(false);
        setTimeout(onModalClose, 100);
      }
    });
  };
  return (
    <Dialog onClose={onModalClose} size="small">
      <MarkasCompletedContainer>
        <MarkValue>
          Are you sure, you want to make an Approval Request for this
          Transaction?
        </MarkValue>
        <CompletedFooter>
          {saving && (
            <CompleteSavingIndicator>
              <FontAwesomeIcon
                color={primaryColor}
                icon={faCircleNotch}
                size="lg"
                spin
              />
            </CompleteSavingIndicator>
          )}
          <CancelButton>
            <Button variant="text" size="medium" onClick={onModalClose}>
              Cancel
            </Button>
          </CancelButton>
          <ChecklistButtonContainer disabled={saving}>
            <Button
              variant="primary"
              size="medium"
              width="100%"
              type="submit"
              onClick={submitChecklistData}>
              Ok
            </Button>
          </ChecklistButtonContainer>
        </CompletedFooter>
      </MarkasCompletedContainer>
    </Dialog>
  );
}
